import React from 'react';
import { Queue } from '../features/queue/Queue';

function Home() {
    return <div>
        <Queue />
    </div>;
}

export default Home;